import {Controller, FieldValues, FormProvider, UseFormReturn} from 'react-hook-form';
import {Grid2, TextField, Typography} from '@mui/material';
import {t} from 'ttag';
import React from 'react';

export const SendInvoiceForm = (methods: UseFormReturn<FieldValues>) => {

  return (
    <FormProvider {...methods}>
      <Grid2 container spacing={2}>
        <Grid2 size={{xs: 12}}>
          <Typography variant={'body2'} fontFamily={'OpenSansMedium'} mb={1}>
            {t`Email Address`}
          </Typography>
          <Controller
            name={'email'}
            control={methods.control}
            render={({field, fieldState}) => (
              <TextField
                {...field}
                fullWidth
                variant={'outlined'}
                size={'small'}
                color={'secondary'}
                placeholder={t`Enter new email address`}
                error={!!fieldState.error}
                helperText={fieldState?.error?.message}
              />
            )}
          />
        </Grid2>
      </Grid2>
    </FormProvider>
  )
}
